import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { objectEntries } from '../utils/object.js';
import { createConnectionContext, createUseConnectionIdRegister, createUseConnectionConsumer, createConnector, createUseConnectionRegister } from './use-connections.js';

const A11yAttributeMapping = {
    description: 'aria-describedby',
    label: 'aria-labelledby',
    htmlFor: 'htmlFor',
    shortcut: 'aria-keyshortcuts',
};
const A11yConnectionContext = createConnectionContext();
/** A11y connector context for registering and consuming a11y ids. */
const A11yConnector = createConnector(A11yConnectionContext, ['description', 'label', 'htmlFor', 'shortcut'], 'A11yConnector');
/** Consume a11y connection values registered under the nearest `A11yConnector` parent. */
const useA11yConsumer = createUseConnectionConsumer(A11yConnectionContext, formatter);
/** Register a11y connection values with the nearest `A11yConnector` parent. */
const useA11yRegister = createUseConnectionRegister(A11yConnectionContext);
/** Register a11y connection ids with the nearest `A11yConnector` parent. */
const useA11yIdRegister = createUseConnectionIdRegister(A11yConnectionContext);
/** Higher order component for hooking up the context to the a11y connectors. */
function withA11yConnector(Component) {
    // Display name gets set by the caller
    // eslint-disable-next-line react/display-name
    const WithA11yConnector = forwardRef((props, ref) => (jsx(A11yConnector, { children: jsx(Component, { ...props, ref: ref }) })));
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return WithA11yConnector;
}
function formatter(connections) {
    return objectEntries(connections).reduce((acc, [type, values]) => {
        if (values.length) {
            const attribute = A11yAttributeMapping[type];
            acc[attribute] = values.join(' ');
        }
        return acc;
    }, {});
}

export { A11yConnector, useA11yConsumer, useA11yIdRegister, useA11yRegister, withA11yConnector };
//# sourceMappingURL=use-a11y-connections.js.map
